<template>
  <b-container fluid class="intro p-0">           
    <b-row class="mx-0 d-flex align-items-center">
      <b-col cols="12" lg="4" class="p-5 text-right content">
        <div>
          <h2 class="display-4 text-dark-color upper bold">4 problèmes majeurs<br>
          <span class="text-blue">auxquels nous nous attaquons</span></h2>
        </div>
      </b-col>

      <b-col cols="12" lg="8" class="p-5 content">
        <b-tabs nav-class="intro-tabs" pills justified active-tab-class="mt-1" active-nav-item-class="" align="center">
          <b-tab v-for="(item, index) in facts" v-bind:key="item.chartName" title-link-class="p-0"> 
            <template slot="title">
              <div class="w-100 text-center p-3"><font-awesome-icon :icon="item.icon" size="3x" /></div>
              <div class="w-100 text-center upper pb-3"><h5 v-html="item.title"></h5></div>
            </template>

            <b-row class="pt-5">
              <b-col class="text-dark-color">
                <h3 class="upper bold">Problème {{ index + 1 }}: <span class="text-red">{{ item.title }}</span></h3>
                <p v-for="(p, index) in item.text" :key="'p-' + index">{{ p }}</p>
                <p><b-link class="text-blue" :to="item.link" title="">En savoir plus...</b-link></p>
              </b-col>

              <b-col class="d-flex justify-content-center chart-div">
                <GChart
                  :name="item.chartName"
                  :type="item.chartType"
                  :data="item.chartData"
                  :options="item.chartOptions"
                />
              </b-col>
            </b-row>
          </b-tab>
        </b-tabs>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
export default {
  name: 'Intro',
  data() {
    return {
      facts: [
        {
          title: `Le temps`,
          icon: `stopwatch`,
          text: [
            `Le temps consacré à des tâches sans valeur ajoutée, telles que la recherche de documents, le classement de documents et la saisie de données manuelle.`,
          `Saviez-vous que l'employé moyen consacre de 30 à 40% de son temps à la recherche d'information dans des documents, courriels ou unités de stockage partagées?`
          ],
          link: { name: `blog` },
          chartName: `time-chart`,
          chartType: `PieChart`,
          chartData: [
            ['Tâches', 'Charge de travail'],
            ['Tâches sans valeur ajoutée', 40],
            ['Tâches à valeur ajoutée', 60]
          ],
          chartOptions: {
            pieSliceText: 'none',
            tooltip: { trigger: 'none' },
            fontSize: '20px',
            chartArea: {
              width: '90%',
              height: '90%'
            },
            tooltip: {
              position: 'none'
            },
            legend: {
              position: 'none'
            },
            pieHole: 0.6,
            backgroundColor: 'transparent',
            colors: [
              'red', 
              '#001216'
            ]
          }
        },
        {
          title: `La sécurité`,
          icon: `shield-alt`,
          text: [
            `Les risques de perte, de vol, d'endommagement et de destruction des documents archivés ainsi que des données qu'ils contiennent.`,
            `Saviez-vous que 61% des violations de données dans les entreprises de moins de 500 employés impliquent des enregistrements papier?`
          ],
          link: { name: `blog` },
          chartName: `security-chart`,
          chartType: `PieChart`,
          chartData: [
            ['Violations de données', 'Répartition'],
            ['Enregistrements papier', 61],
            ['Enregistrements numériques', 39]
          ],
          chartOptions: {
            pieSliceText: 'none',
            tooltip: { trigger: 'none' },
            fontSize: '20px',
            chartArea: {
              width: '90%',
              height: '90%'
            },
            tooltip: {
              position: 'none'
            },
            legend: {
              position: 'none'
            },
            pieHole: 0.6,
            backgroundColor: 'transparent',
            colors: [
              'red', 
              '#001216'
            ]
          }
        },
        {
          title: `Les coûts`,
          icon: `dollar-sign`,
          text: [
            `Les coûts associés à l'impression des documents et à l'espace consacré à l'entreposage de ceux-ci.`,
            `Saviez-vous qu'il coûte en moyenne 20$ aux organisations pour classer un seul document?`
          ],
          link: { name: `blog` },
          chartName: `costs-chart`,
          chartType: `LineChart`,
          chartData: [
            ['Documents à classer', 'Coût'],
            [0, 0],
            [20, 400],
            [40, 800],
            [60, 1200],
            [80, 1600],
            [100, 2000]
          ],
          chartOptions: {
            vAxis: {
              viewWindowMode:'explicit',
              viewWindow: {
                max:2500,
                min:0
              }
            },
            hAxis: {
              viewWindowMode:'explicit',
              viewWindow: {
                max:100,
                min:0
              }
            },
            fontSize: '20px',
            chartArea: {
              width: '90%',
              height: '90%'
            },
            tooltip: {
              position: 'none'
            },
            legend: {
              position: 'none'
            },
            backgroundColor: 'transparent',
            colors: [
              'red'
            ]
          }
        },
        {
          title: `L'inefficacité`,
          icon: `exclamation-triangle`,
          text: [
            `L'inefficacité des processus attribuable aux transits de documents et aux erreurs humaines.`,
            `Saviez-vous que 92% des employés collaborent sur des documents en utilisant la messagerie électronique?`
          ],
          link: { name: `blog` },
          chartName: `efficiency-chart`,
          chartType: `PieChart`,
          chartData: [
            [`Causes d'innefficacité organisationnelle`, 'Courriels comme outil de collaboration'],
            ['Employés utilisant le courriel', 92],
            ['Employés utilisant une solution efficace', 8]
          ],
          chartOptions: {
            pieSliceText: 'none',
            tooltip: { trigger: 'none' },
            fontSize: '20px',
            chartArea: {
              width: '90%',
              height: '90%'
            },
            tooltip: {
              position: 'none'
            },
            legend: {
              position: 'none'
            },
            pieHole: 0.6,
            backgroundColor: 'transparent',
            colors: [
              'red', 
              '#001216'
            ]
          }
        }
      ]
    }
  },
  methods: {
    normalizeString(string) {
        return string.split('').map(function (letter) {
            let i = this.accents.indexOf(letter)
            return (i !== -1) ? this.out[i] : letter
            }.bind({
            accents: 'ÀÁÂÃÄÅĄàáâãäåąßÒÓÔÕÕÖØÓòóôõöøóÈÉÊËĘèéêëęðÇĆçćÐÌÍÎÏìíîïÙÚÛÜùúûüÑŃñńŠŚšśŸÿýŽŻŹžżź',
            out: 'AAAAAAAaaaaaaaBOOOOOOOOoooooooEEEEEeeeeeeCCccDIIIIiiiiUUUUuuuuNNnnSSssYyyZZZzzz'
            })
        ).join('')
    }
  }
}
</script>

<style>
.intro-tabs > li > .nav-link.active {
  background-color: #00B5E2 !important;
  border-radius: 0 !important;
}

.intro-tabs > li > .nav-link > div {
  transition: all 0.3s ease;
}

.intro-tabs > li > .nav-link:hover > div {
  background-color: rgba(0,181,226, 0.3) !important;
}

.intro-tabs > li > .nav-link:hover > div > h5,
.intro-tabs > li > .nav-link:hover > div > svg {
  color: #fff !important;
}

.intro-tabs > li > .nav-link.active > div > h5,
.intro-tabs > li > .nav-link.active > div > svg {
  color: #fff;
}

.intro-tabs > li > .nav-link > div > h5,
.intro-tabs > li > .nav-link > div > svg {
  color: #00B5E2;
  margin: 0;
}
</style>
